<template>
    <div>
        <b-alert variant="info" :show="true" v-for="notification in notifications" :key="notification.secret_key">
            <p v-html="nl2br(notification.message)"></p>
        </b-alert>

        <b-modal ref="global-notification-modal"
                 size="lg"
                 no-close-on-backdrop
                 no-close-on-esc
                 hide-header>
            <template #default>
                <p v-html="nl2br(modalMessage)"></p>
            </template>
            <template #modal-footer class="text-right">
                <button type="button" class="btn btn-light" @click="hideNotificationsModal">{{ trans('common.ok') }}</button>
            </template>
        </b-modal>
    </div>
</template>

<script>

    import Utils from '@/services/Utils';
    import GlobalNotificationsController from '@/services/Admin/GlobalNotificationsController';

    export default {

        data() {
            return {
                notifications: [],
                modalMessage: '',
                shownNotificationPopups: [],
                modalIsVisible: false,
                reloadTimer: null
            };
        },

        created() {
            this.loadGlobalNotifications();

            const self = this;

            // check every minute
            this.reloadTimer = setInterval(function () {
                self.loadGlobalNotifications();
            }, 60000);
        },

        methods: {

            loadGlobalNotifications() {
                GlobalNotificationsController.showActive()
                    .then(notifications => {
                        this.notifications = notifications.data;

                        if (!this.modalIsVisible) {
                            this.modalMessage = '';
                            if (this.notifications.length) {
                                const messages = [];

                                this.notifications.forEach(notification => {
                                    if (this.shownNotificationPopups.indexOf(notification.secret_key) < 0
                                        && notification.show_final_warning
                                        && notification.final_warning_message
                                        && notification.final_warning_start
                                            <= this.currentDatetimeFormatted('YYYY-MM-DD HH:mm:ss')
                                        && notification.final_warning_end
                                            >= this.currentDatetimeFormatted('YYYY-MM-DD HH:mm:ss')
                                    ) {
                                        messages.push(notification.final_warning_message);
                                        this.shownNotificationPopups.push(notification.secret_key);
                                    }
                                });

                                if (messages.length) {
                                    this.modalMessage += `${messages.map(msg => `${msg}`).join('<br><br>')}`;
                                    this.showNotificationsModal();
                                }
                            }
                        }
                    });
            },

            showNotificationsModal() {
                this.$refs['global-notification-modal'].show();
                this.modalIsVisible = true;
            },

            hideNotificationsModal() {
                this.$refs['global-notification-modal'].hide();
                this.modalIsVisible = false;
            },

            nl2br(string) {
                return Utils.nl2br(string);
            }

        },

        beforeDestroy: function () {
            clearInterval(this.reloadTimer);
        }

    };

</script>



// WEBPACK FOOTER //
// src/components/Alerts/GlobalNotifications.vue